import { useEffect } from 'react'
import { gql, useLazyQuery } from '@apollo/client'
import moment from 'moment-timezone'
import useExcelDownload from './useExcelDownload'
import counselingPlanQueryResult from '../../../Pages/CounselingPlans/Model/queryResults/planQueryResult'
import { getValues } from '../../../Pages/CounselingPlans/Columns/util'
import useGetAllTags from '../../../Pages/Constants/Tags/Model/useGetAllTags'
const useDownLoadExcelPlans = () => {
  //eslint-disable-next-line
  const [getAllTags, { data: dataTags, loading: loadingTags, error: errorTags, refetch: refetchTags }] = useGetAllTags()
  useEffect(() => {
    getAllTags()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const exportToCSV = useExcelDownload()
  return useLazyQuery(
    gql`query (
        $sortField: String,
        $previous: String,
        $next: String,
        $limit: Int,
        $to: DateTime,
        $from: DateTime,
        $status: [PlanStatus!]!,
        $studentsUserIds: [ID!],
        $serviceIds: [ID!],
        $kind: [PlanKind!]!,
        $topicIds: [ID!]
        $educatorUserIds: [ID!]
        $countryIds: [ID!]
        $lessonsPending: Int
        $endDateFilter: [DateTime!]
        $startDateFilter: [DateTime!]
        $finishSoon: Boolean
        $lastApproved: Boolean
        $previouslySent: Boolean
        $shortRecenlySent: Boolean
        $testDate: DateTime
        ){
      plans (
        sortField: $sortField,
        previous: $previous,
        next: $next,
        limit: $limit,
        to: $to,
        from: $from,
        status: $status,
        studentsUserIds: $studentsUserIds,
        serviceIds: $serviceIds,
        kind: $kind,
        topicIds: $topicIds
        educatorUserIds: $educatorUserIds
        countryIds: $countryIds
        lessonsPending: $lessonsPending
        endDateFilter: $endDateFilter
        startDateFilter: $startDateFilter
        finishSoon: $finishSoon
        lastApproved: $lastApproved
        previouslySent: $previouslySent
        shortRecenlySent: $shortRecenlySent
        testDate: $testDate
      ){
        hasNext
        hasPrevious
        totalDocs
        docs {
          ... on CouncelingPlan {
            ${counselingPlanQueryResult}
          }
          id
          name
          cancelDate
          pauseDate
          resumeDate
          studentUser {
            studentUserId
            firstName
            lastName
            rate
            isManualRate
          }
          serviceId
          lessonIds
          paymentItemIds
          paymentItemsConfig {
            amount
            percentDiscount 
            amountWithoutDiscount
            date
            description
            type
          }
          status
          kind
          createdAt
          updatedAt  
          isFirstPlan
          typePlanPricing
          pricingRate
          groupPricingRate
          groupId
          from
          to
          ... on GroupPlan {
          studentPlans {
            studentId
            planId
            registerDate
            planStatus
          }
          lessonGroupIds
          childPlans {
            id
            name
            cancelDate
            pauseDate
            resumeDate
            studentUser {
              studentUserId
              firstName
              lastName
              rate
              isManualRate
            }
            serviceId
            lessonIds
            paymentItemIds
            paymentItemsConfig {
              amount
              percentDiscount 
              amountWithoutDiscount
              date
              description
              type
            }
            status
            kind
            createdAt
            updatedAt  
            isFirstPlan
            typePlanPricing
            pricingRate
            groupPricingRate
            location {
              type
            }
            groupId
            from
            to
            testDate
            ... on LessonsPerWeekPlan {
              testDate
            }          
          }
          }
          ... on LessonsPerWeekPlan {
            getStudentInfo {
             graduationDate
             tags
             studentEmail
             classOf
             countryStudent {
                name
             }
             parents {
                email
                firstName
                lastName
             }
            }
            testDate
          }
        }
      }
    }`,
    {
      fetchPolicy: 'no-cache',
      onCompleted: ({ plans }) => {
        exportToCSV(
          plans?.docs?.map((plan) => {
            const {
              studentUser,
              name,
              status,
              paymentItemsConfig,
              createdAt,
              getStudentInfo,
            } = plan
            const getClassOf = (graduationDate) => {
              const classof = getValues(moment(graduationDate).toISOString(), 'class')
              return parseInt(classof)
            }
            return {
              // StudentFname: `${studentUser?.firstName}`,
              // StudentLname: `${studentUser?.lastName}`,
              student: `${studentUser?.firstName} ${studentUser?.lastName}`,
              planName: name,
              status,
              StudentEmail: getStudentInfo?.studentEmail,
              Tags: getStudentInfo?.tags?.length
                ? getStudentInfo.tags
                  .map(tagId =>
                    dataTags?.allTags?.docs?.find(tag => tag.id === tagId && tag.isActive === true)?.name
                  )
                  .filter(Boolean)
                  .join(', ')
                : '',

              ClassOf: getClassOf(getStudentInfo?.graduationDate),
              // PlanName: name,
              createdAt: moment(createdAt).startOf('day').fromNow(),
              studentCountry: getStudentInfo?.countryStudent?.name,
              parentFname: `${getStudentInfo?.parents[0]?.firstName}`,
              parentLname: `${getStudentInfo?.parents[0]?.lastName}`,
              parentEmail: getStudentInfo?.parents[0]?.email,
              totalAmount: paymentItemsConfig?.map(({ amount }) => (amount)).reduce((a, b) => a + b, 0),
            }
          }),
          "Plans"
        )
      }
    }
  )
}

export default useDownLoadExcelPlans
